<template>
  <v-dialog v-model="dialog" max-width="800px" persistent>
    <v-card v-if="product">

      <v-card-text>
        <v-container>
          <product-service :content="product" />
          <availability :data="product" :onChange="handleUpdateAvailability" />
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn class="mr-4" @click="onClose">{{ $t('common.cancel') }}</v-btn>
        <v-btn dark :color="enterpriseColor" @click="handleSave">{{ $t('common.save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import Availability from '@/components/Availability'
  import ProductService from '../menus/formMenu/content/productService/Index'
  export default {
    components: {
      Availability,
      ProductService
    },
    props: {
      dialog: {
        type: Boolean,
        required: true
      },
      data: {
        type: Object,
        required: false,
        default: null
      },
      onSave: {
        type: Function,
        required: true
      },
      onClose: {
        type: Function,
        required: true
      }
    },
    data: () => ({
      product: null
    }),
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      }
    },
    watch: {
      data: {
        handler: function (newValue) {
          this.product = newValue
        },
        deep: true
      },
    },
    mounted () {
      this.product = this.data
    },
    methods: {
      handleUpdateAvailability (value) {
        // this.dishe.Availability = value
        this.product.IsTemp = value.isTemp
        this.product.Per = value.per
        this.product.DateStart = value.dateStart
        this.product.DateEnd = value.dateEnd
        this.product.TimeStart = value.timeStart
        this.product.TimeEnd = value.timeEnd
        this.product.IsAllTimes = value.isAllTimes
        this.product.IsAllDays = value.isAllDays
        this.product.Rec = value.rec
        this.product.DayOfWeek = value.dayOfWeek
        this.product.DayOfMonth = value.dayOfMonth
        this.product.Alt = value.alt
      },
      handleSave () {
        this.onSave(this.product)
      }
    }
  }
</script>
